export enum UserRole {
	ROLE_ROOT_ACCOUNT = 'ROLE_ROOT_ACCOUNT', // 管理員
	ROLE_SUPERVISOR = 'ROLE_SUPERVISOR', // 督導
	ROLE_PROJECT_IN_CHARGE = 'ROLE_PROJECT_IN_CHARGE', // 主任
	ROLE_PROFESSIONAL_STAFF = 'ROLE_PROFESSIONAL_STAFF', // 專業同工
	ROLE_SUPPORTING_STAFF = 'ROLE_SUPPORTING_STAFF', // 支援同工
}
